'use client';

import { useMemo, useRef } from 'react';

import { useLocale } from 'next-intl';
import dynamic from 'next/dynamic';

import {
  formatAssetNameToTradingViewWidgetPropsFormat,
  getDateFormatFromLocale,
  ourLocaleToTwLocale,
} from '@/blocks/components/TW';

import { Asset as LocalAsset } from '@/app/[lang]/price-chart/[category]/types';

import styles from './styles.module.scss';

const SymbolOverviewNoSSR = dynamic(
  () => import('react-ts-tradingview-widgets').then((w) => w.SymbolOverview),
  {
    ssr: false,
  },
);

export function Chart({ asset }: { asset: LocalAsset }) {
  const locale = useLocale();
  const ref = useRef<HTMLDivElement | null>(null);

  return useMemo(
    () => (
      <div className={styles.mainCardChart} ref={ref}>
        {/* TODO maybe similar assets */}
        <SymbolOverviewNoSSR
          dateFormat={getDateFormatFromLocale(locale)}
          // prettier-ignore
          symbols={[
            [
              asset.name,
              formatAssetNameToTradingViewWidgetPropsFormat(asset.name),
            ],
          ]}
          autosize
          lineWidth={1}
          locale={ourLocaleToTwLocale(locale)}
        />
      </div>
    ),
    [asset.name, locale],
  );
}
